import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { toJS } from 'mobx'

import Spinner from '@components/spinner'
import Checkbox from '@components/Checkbox'
import { SearchPanelContainer } from '@components/Search'
import FilterGroup from '@components/FilterGroup'

class Filters extends Component {
  static propTypes = {
    historyStore: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    changePage: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    props.historyStore.getStatusCountFilters()
  }

  onClearSearch = () => {
    this.props.historyStore.clearSearch()
    this.props.changePage(1)
  }

  applyEplStatusFilter = id => {
    this.props.historyStore.updateEplStatusFilters(id)
    this.props.changePage(1)
  }

  applyReplyStatusFilter = id => {
    this.props.historyStore.updateReplyStatusFilters(id)
    this.props.changePage(1)
  }

  componentWillUnmount () {
    this.props.historyStore.clearSearch()
  }

  renderEplStatusFilters = () => {
    const { eplStatusCount, selectedEplStatusFilters } = this.props.historyStore
    const { eplStatuses } = this.props.staticData

    return eplStatuses.map(eplStatus => {
      const eplStatusesCount = eplStatusCount.find(
        eplStatusCount => eplStatusCount.eplStatusId === eplStatus.id
      )
      let count = 0

      if (eplStatusesCount) count = eplStatusesCount.count

      return (
        <div className='expert-history-filters-wrapper' key={eplStatus.id}>
          <Checkbox
            value={toJS(selectedEplStatusFilters).includes(eplStatus.id)}
            label={`${eplStatus.name} (${count})`}
            onChange={() => this.applyEplStatusFilter(eplStatus.id)}
            noLeftMargin
          />
        </div>
      )
    })
  }

  renderReplyStatusFilters = () => {
    const {
      replyStatusCount,
      selectedReplyStatusFilters
    } = this.props.historyStore
    const { replyStatuses } = this.props.staticData

    return replyStatuses.map(replyStatus => {
      const replyStatusesCount = replyStatusCount.find(
        replyStatusCount => replyStatusCount.replyStatusId === replyStatus.id
      )
      let count = 0

      if (replyStatusesCount) count = replyStatusesCount.count

      return (
        <div className='expert-history-filters-wrapper' key={replyStatus.id}>
          <Checkbox
            value={toJS(selectedReplyStatusFilters).includes(replyStatus.id)}
            label={`${replyStatus.name} (${count})`}
            onChange={() => this.applyReplyStatusFilter(replyStatus.id)}
            noLeftMargin
          />
        </div>
      )
    })
  }

  render () {
    const { loadingFilters } = this.props.historyStore

    if (loadingFilters) return <Spinner />

    return (
      <div className='animate-intro'>
        <SearchPanelContainer
          searchTitle={"Expert's Projects - Summary & Filters"}
          onClearSearch={this.onClearSearch}
          clearSearchText='Clear All Filters'
          expertHistory
        >
          <FilterGroup
            label='EPL Status'
            labelClass='filter-group__label-bold'
            displayFlex
          >
            {this.renderEplStatusFilters()}
          </FilterGroup>
          <FilterGroup
            label='EPL Reply Status'
            labelClass='filter-group__label-bold'
            displayFlex
          >
            {this.renderReplyStatusFilters()}
          </FilterGroup>
        </SearchPanelContainer>
      </div>
    )
  }
}

export default inject('historyStore', 'staticData')(observer(Filters))
